import {Base} from "@/api/Base"

export class LeaveTypeListAll extends Base {
    path = "leaveType/listAll"
}